var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66634 14.0007L9.33301 11.334H13.333C13.6997 11.334 14.0137 11.4644 14.275 11.7253C14.5359 11.9867 14.6663 12.3007 14.6663 12.6673C14.6663 13.034 14.5359 13.348 14.275 13.6093C14.0137 13.8702 13.6997 14.0007 13.333 14.0007H6.66634ZM2.66634 12.6673H3.59967L9.34967 6.91732L8.41634 5.98398L2.66634 11.734V12.6673ZM12.1997 5.95065L9.36634 3.15065L10.2997 2.21732C10.5552 1.96176 10.8692 1.83398 11.2417 1.83398C11.6137 1.83398 11.9275 1.96176 12.183 2.21732L13.1163 3.15065C13.3719 3.40621 13.5052 3.71465 13.5163 4.07598C13.5275 4.43687 13.4052 4.7451 13.1497 5.00065L12.1997 5.95065ZM1.99967 14.0007C1.81079 14.0007 1.65256 13.9367 1.52501 13.8087C1.39701 13.6811 1.33301 13.5229 1.33301 13.334V11.4507C1.33301 11.3618 1.34967 11.2758 1.38301 11.1927C1.41634 11.1091 1.46634 11.034 1.53301 10.9673L8.39967 4.10065L11.233 6.93398L4.36634 13.8007C4.29967 13.8673 4.22479 13.9173 4.14167 13.9507C4.05812 13.984 3.9719 14.0007 3.88301 14.0007H1.99967ZM8.88301 6.45065L8.41634 5.98398L9.34967 6.91732L8.88301 6.45065Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.56df60d886650db7f0c2387c17d26f03.svg";
export { ForwardRef as ReactComponent };